import { Routes } from '@angular/router';
import { LoginComponent } from './Common/login/login.component';
import { HomeComponent } from './Dashboard/home/home.component';
import { AuthGuard } from './auth.guard';
import { TermsConditionComponent } from './Common/terms-condition/terms-condition.component';
import { EconetComponent } from './Common/econet/econet.component';
import { FAQComponent } from './Common/faq/faq.component';
import { PrivacyPolicyComponent } from './Common/privacy-policy/privacy-policy.component';
import {AddNotificationComponent} from './add-notification/add-notification.component'
import { EventNotificationsComponent } from './event-notifications/event-notifications.component';

export const routes: Routes = [
    {path:'', pathMatch:'full', redirectTo:'login'},
    {path:'login', component:LoginComponent,canActivate: [AuthGuard]},
    {path:'terms-condition', component:TermsConditionComponent},
    {path:'econet', component:EconetComponent},
    {path:'feqs', component:FAQComponent},
    {path:'privacy-policy', component:PrivacyPolicyComponent},
    {path:'dashboard', component:HomeComponent, canActivate: [AuthGuard]},
    {path:'add-notification', component: AddNotificationComponent },
    {path:'event-notification',component:EventNotificationsComponent},
    { path: '**', redirectTo: 'login' }
];
